import React from 'react';
import { AkinatorCompletion } from 'types/suggestions';
import {
  akinatorCompletionButton,
  akinatorCompletionButtonText,
  akinatorCompletionsItems,
  akinatorCompletionsWrap,
} from './styles';
import { cx } from 'linaria';
import { RegularButton } from 'fronton-react';

type CompletionsAkinatorProps = {
  completions: AkinatorCompletion[];
  navigationIndex: number;
  onMouseEnter: (idx: number) => void;
  onMouseLeave: () => void;
  onCompletionClick: (completion: AkinatorCompletion) => void;
};

export const DATA_QA_COMPLETIONS_AKINATOR = 'completions-akinator';

export const CompletionsAkinator: React.FC<CompletionsAkinatorProps> = ({
  completions,
  navigationIndex,
  onMouseEnter,
  onMouseLeave,
  onCompletionClick,
}) => {
  return (
    <div className={akinatorCompletionsWrap} data-qa={DATA_QA_COMPLETIONS_AKINATOR}>
      <div className={akinatorCompletionsItems}>
        {completions.map((completion, elementIndex) => {
          const isSelected = elementIndex === navigationIndex;

          return (
            <RegularButton
              key={`${completion.name}_${completion.type}`}
              id={`akinator-completion-${elementIndex}`}
              variant="outline"
              rounded
              size="s"
              aria-selected={isSelected}
              className={cx(akinatorCompletionButton, isSelected && 'active')}
              onMouseEnter={() => onMouseEnter(elementIndex)}
              onMouseLeave={onMouseLeave}
              onClick={() => onCompletionClick(completion)}
            >
              <span className={akinatorCompletionButtonText}>{completion.name}</span>
            </RegularButton>
          );
        })}
      </div>
    </div>
  );
};
